export default __webpack_public_path__ + "ac3ce8d8ba58fc70d1f2affa1e9a08a8.png";